import React from "react";
import { Container } from "react-bootstrap";
import Particle from "../Particle";
import Timeline from "../Timeline/Timeline";
import researchData from "./ResearchData";

function Research() {
  return (
    <Container fluid className="project-section">
      <Particle />
      <Container>
        <h1 className="project-heading" style={{ paddingBottom: "10px" }}>
          我的<strong className="purple"> 科研 </strong>经历
        </h1>
        <p style={{ color: "rgba(26,26,26,0.6)", marginBottom: "10px" }}>
          以时间轴形式记录科研探索、论文成果与学术贡献。
        </p>
        <Timeline items={researchData} />
      </Container>
    </Container>
  );
}

export default Research;
